import React from "react";
import {cn} from "../utils";

const BarChartIcon = (
    {
        className,
        color
    }: {
        className?: string,
        color?: string
    } & React.SVGProps<SVGSVGElement>) => (
    <svg fill="none"
         height="512"
         width="512"
         viewBox="0 0 24 24"
         className={cn(className)}
         xmlns="http://www.w3.org/2000/svg">
        <g clipRule="evenodd"
           fill={color || "currentColor"}
           fillRule="evenodd">
            <path
                d="m9.25 5c0-1.51878 1.2312-2.75 2.75-2.75s2.75 1.23122 2.75 2.75v14c0 1.5188-1.2312 2.75-2.75 2.75s-2.75-1.2312-2.75-2.75zm2.75-1.25c-.6904 0-1.25.55964-1.25 1.25v14c0 .6904.5596 1.25 1.25 1.25s1.25-.5596 1.25-1.25v-14c0-.69036-.5596-1.25-1.25-1.25z"/>
            <path
                d="m1.25 10c0-1.51878 1.23122-2.75 2.75-2.75s2.75 1.23122 2.75 2.75v9c0 1.5188-1.23122 2.75-2.75 2.75s-2.75-1.2312-2.75-2.75zm2.75-1.25c-.69036 0-1.25.55964-1.25 1.25v9c0 .6904.55964 1.25 1.25 1.25s1.25-.5596 1.25-1.25v-9c0-.69036-.55964-1.25-1.25-1.25z"/>
            <path
                d="m17.25 10c0-1.51878 1.2312-2.75 2.75-2.75s2.75 1.23122 2.75 2.75v9c0 1.5188-1.2312 2.75-2.75 2.75s-2.75-1.2312-2.75-2.75zm2.75-1.25c-.6904 0-1.25.55964-1.25 1.25v9c0 .6904.5596 1.25 1.25 1.25s1.25-.5596 1.25-1.25v-9c0-.69036-.5596-1.25-1.25-1.25z"/>
        </g>
    </svg>
);

export {BarChartIcon};